import { render } from "./QuienesSomos.vue?vue&type=template&id=35d30906&scoped=true"
import script from "./QuienesSomos.vue?vue&type=script&lang=js"
export * from "./QuienesSomos.vue?vue&type=script&lang=js"

import "./QuienesSomos.vue?vue&type=style&index=0&id=35d30906&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d30906"]])

export default __exports__